<template>
  <header>
    <div class="container">
      <div class="header-wrapper">
        <div class="logo">
          <h1><router-link to="/" exact-active-class="active"> {{ siteData.site.name }} </router-link></h1>
        </div>
        <div class="search-bar">
          <input type="text" placeholder="Search for products..." v-model="headers.headerData.search">
          <button class="search-data-clear" style="background-color: aliceblue;"> <i class="fa fa-times"></i> </button>
          <button class="search-data-search"><i class="fas fa-search"></i></button>
        </div>
        <nav class="main-nav" :class="{ active: mobileMenuOpen }">
          <ul>
            <li><router-link to="/" exact-active-class="active">Home</router-link></li>
            <!-- <li><router-link to="/products/categories" exact-active-class="active">Categories</router-link></li> -->
            <!-- <li><router-link to="/products" exact-active-class="active">Products</router-link></li> -->
            <li class="nav-dropdown">
              <a href="javascript:void(0)" class="dropbtn">Products <i class="fa-solid fa-chevron-down"></i> </a>
              <div class="nav-dropdown-content">
                <router-link to="/products" exact-active-class="active">All Product</router-link>
                <router-link to="/products/categories" exact-active-class="active">Categories</router-link>
                <router-link to="/products/wishlist" exact-active-class="active">Wish List</router-link>
                <router-link to="/products/cart" exact-active-class="active">Cart</router-link>
                <router-link to="/products/track" exact-active-class="active">Track  Orders</router-link>
              </div>
            </li>
            <li class="nav-dropdown">
              <a href="javascript:void(0)" class="dropbtn">Contacts <i class="fa-solid fa-chevron-down"></i> </a>
              <div class="nav-dropdown-content">
                <router-link to="/contacts/ai" exact-active-class="active">Chat With AI</router-link>
                <router-link to="/contacts/q&a" exact-active-class="active">Q & A</router-link>
                <router-link to="/contacts/report" exact-active-class="active">Report</router-link>  
                <router-link to="/contacts/suggestions" exact-active-class="active">Suggestions</router-link>
              </div>
            </li>
            <li class="nav-dropdown">
              <a href="javascript:void(0)" class="dropbtn">Site <i class="fa-solid fa-chevron-down"></i> </a>
              <div class="nav-dropdown-content">
                <router-link to="/site/blog" exact-active-class="active">Blog</router-link>
                <router-link to="/site/news" exact-active-class="active">News</router-link>
                <router-link to="/docs" exact-active-class="active">Documantation</router-link>
                <router-link to="/site/datasheets" exact-active-class="active">Data Sheets</router-link>
                <router-link to="/site/safety" exact-active-class="active">Industrial Safety</router-link>
                <hr>
                <router-link to="/about" exact-active-class="active">About</router-link>
                <router-link to="/site/version" exact-active-class="active">Updates</router-link>
              </div>
            </li>
            <li><router-link to="/products/wishlist" exact-active-class="active"><i
                  class="fas fa-heart"></i></router-link></li>
            <li>
              <router-link to="/products/cart" exact-active-class="active">
                <i class="fas fa-shopping-cart"></i>
                <span class="cart-count" v-if="cart.headerData.cart.length > 0">
                  {{ cart.headerData.cart.length < 99 ? cart.headerData.cart.length : "99+" }}</span>
              </router-link>
            </li>
            <li @click="toggleDropdown" style="cursor: pointer;">
              <i class="fas fas fa-spinner fa-spin" v-if="isLoading"></i>  
              <i class="fas fa-user" v-else></i> 
               Account</li>
          </ul>

        </nav>
        <div class="mobile-menu-toggle" @click="toggleMobileMenu">
          <i class="fas fa-bars"></i>
        </div>
      </div>
    </div>

    <div v-if="isOpen" class="dropdown-content" v-click-outside="closeDropdown">
      <div style="width: 100%; text-align: right;">
        <i class="fa-solid fa-times" @click="toggleDropdown"></i>
      </div>
      <div v-if="isLoggedIn" class="user-profile">
        <div class="profile-header">
          <img :src="this.userAcc.userProfile?.profilePicture ? imageHandler(this.userAcc.userProfile.profilePicture) : defaultProfilePic" alt="Profile Picture" class="profile-pic">
          <div class="profile-info">
            <span class="username">@{{ this.userAcc.userProfile ? this.userAcc.userProfile.username : "User Name" }}</span>
            <span class="fullname">{{ this.userAcc.userProfile? `${this.userAcc.userProfile.firstName} ${this.userAcc.userProfile.lastName}` : "Full Name" }}</span>
            <span class="email">{{ this.userAcc.userProfile? this.userAcc.userProfile.email : "E-mail Address" }}</span>
          </div>
        </div>
      </div>
      <div class="auth-buttons" :class="{ 'logged-out': !isLoggedIn }">
        <button v-if="this.userAcc.userLoginValidate()" class="profile-button" @click="navigateToProfile">Profile</button>
        <button v-if="!isLoggedIn" class="login-button" @click="login">Login</button>
        <button v-if="!isLoggedIn" class="register-button" @click="register">Register</button>
        <button v-if="isLoggedIn" class="logout-button" @click="logout">Logout</button>
      </div>
    </div>

    <div class="fab-container" :class="{ 'expanded': isFabExpanded }">
      <!-- Modern Close Button -->
      <button @click="fabOrPanel = false" class="modern-close-btn" v-if="fabOrPanel">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <!-- Modern FAB Main Button -->
      <button v-if="!fabOrPanel" class="modern-fab-main" @click="toggleMenu" :aria-expanded="isFabExpanded">
        <span class="fab-icon">
          <transition name="rotate" mode="out-in">
            <svg v-if="!isFabExpanded" key="menu" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
            <svg v-else key="close" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </transition>
        </span>
      </button>

      <!-- Modern FAB Options -->
      <transition-group name="fab-option">
        <button v-for="(option, index) in options" :key="option" class="modern-fab-option" v-show="isFabExpanded"
          :style="{ 'transition-delay': `${index * 0.05}s` }" @click="selectOption(option)">
          <div class="option-icon">
            <i :class="option.icon"></i>
          </div>
          <span class="option-label">{{ option.text }}</span>
        </button>
      </transition-group>

      <!-- Modern Side Panel -->
      <!-- <div v-if="fabOrPanel" class="modern-side-panel" :class="{ show: fabOrPanel, hide: !fabOrPanel }">
        <div class="panel-header">
          <h3>{{ fabPanelName }}</h3>
        </div>
        <div class="panel-content">
          <ChatWithAI v-if="fabPanelName === 'AI Assistant'"/>
          <ReportPanel v-if="fabPanelName === 'Report Issues'"/>
          <NewItemsuggestions v-if="fabPanelName === 'Suggest New Item'"/>
        </div>
      </div> -->
      <div v-if="fabOrPanel" class="modern-side-panel" :class="{ show: fabOrPanel, hide: !fabOrPanel }">
        <div class="panel-header">
          <h3>{{ fabPanelName }}</h3>
        </div>
        <div class="panel-content">
          <ChatWithAI v-if="fabPanelName === 'AI Assistant'" />
          <div v-if="fabPanelName === 'Report Issues'" class="report-panel-container">
            <ReportPanel />
          </div>
          <NewItemsuggestions v-if="fabPanelName === 'Suggest New Item'" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import routes from '@/router/routes';
import site from '@/../public/site.json';

import ChatWithAI from '../Handeling/ChatWithAIComponent.vue';
import ReportPanel from '../Handeling/ReportPanelComponent.vue';
import NewItemsuggestions from '../Handeling/NewItemsuggestionsComponent.vue';

import { userAccountStore } from '@/store/loginStore';
import { headerStore } from '@/store/HeaderStore';
import { cartStore } from '@/store/CartStore';

import { PostRequest, ConnectionPath } from '@/network';

export default {
  name: 'HeaderSection',
  components: {
    ChatWithAI,
    ReportPanel,
    NewItemsuggestions
  },
  data() {
    return {
      mobileMenuOpen: false,
      showDropdown: false,
      cartCount: 30,
      isOpen: false,
      isLoggedIn: false,
      defaultProfilePic: require('@/assets/images/uncounUser.png'),
      user: {
        username: ' - no connection -',
        fullName: ' - Check the connection and try again -',
        email: '',
        profilePic: null
      },
      showGoToTop: false,
      fabOrPanel: false,
      fabPanelName: '',
      isFabExpanded: false,
      options: [
        {
          name: "go_top",
          text: "Go Top",
          icon: "fas fa-arrow-up",
          title: null
        }, {
          name: "ai_chat",
          text: "Chat AI",
          icon: "fas fa-robot",
          title: "AI Assistant"
        }, {
          name: "say_new",
          text: "New Item",
          icon: "fas fa-cart-plus",
          title: "Suggest New Item"
        }, {
          name: "report",
          text: "Report",
          icon: "fas fa-flag",
          title: "Report Issues"
        },
      ],

        isLoading:false,
    }
  },
  computed: {
    siteData() {
      return site;
    },
    routes(){
      return routes
    },
    headers() {
      return headerStore();
    },
    userAcc() {
      return userAccountStore();
    },
    cart(){
      return cartStore();
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    imageHandler(imgPath){
      return `${ConnectionPath().api}/profile_picture/${imgPath}`
    },
    toggleMenu() {
      this.isFabExpanded = !this.isFabExpanded
    },
    selectOption(option) {
      if (option.name == "go_top") {
        this.scrollToTop();
      } else if (option.name == "ai_chat") {
        this.fabPanelName = option.title;
        this.fabOrPanel = true;
      } else if (option.name == "report") {
        this.fabPanelName = option.title;
        this.fabOrPanel = true;
      } else if (option.name == "say_new") {
        this.fabPanelName = option.title;
        this.fabOrPanel = true;
      }

      this.isFabExpanded = false
    },
    handleScroll() {
      this.showGoToTop = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    async toggleDropdown() {
      this.isLoading = true;
      this.mobileMenuOpen = false;
      this.isLoggedIn = this.userAcc.userLoginValidate();
      this.devConsole && console.log(this.isLoggedIn)

      this.isOpen = !this.isOpen;
      if (this.isLoggedIn && this.isOpen) {
        const result = await PostRequest(`/api/User/profile?user=${this.userAcc.userToken}`, null, '', 'user');
        if (result.status == 200) {
          this.userAcc.userProfile = result.data;
        }
      }
      this.isLoading = false;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    login() {
      this.$router.push('/user/login');
    },
    register() {
      this.$router.push('/user/register');
    },
    logout() {
      this.$swal.fire({
        title: "Are you sure?",
        text: "Logout After You need re login and use the web site!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then((result) => {
        if (result.isConfirmed) {
          this.userAcc.userLogout("/")
          this.closeDropdown();
        }
      });
      // if()

    },
    navigateToProfile() {
      this.$router.push('/user');
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    }
  }
}
</script>

<style scoped>
/* Modern Close Button */
.modern-close-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(255, 107, 107, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2001;
  backdrop-filter: blur(10px);
}

.modern-close-btn:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 12px 35px rgba(255, 107, 107, 0.4);
  background: linear-gradient(135deg, #ff5252, #d32f2f);
}

.modern-close-btn:active {
  transform: translateY(0) scale(0.95);
}

/* Modern Side Panel */
.modern-side-panel {
  position: fixed;
  top: 80px;
  right: 20px;
  width: 420px;
  max-height: calc(100vh - 120px);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(100%) scale(0.9);
  opacity: 0;
  z-index: 2000;
}

.modern-side-panel.show {
  transform: translateX(0) scale(1);
  opacity: 1;
}

.panel-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.panel-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.panel-content {
  padding: 0;
  height: calc(100% - 80px);
  overflow-y: auto;
}

.container {
  user-select: none;
}

button {
  user-select: none;
}

/* Modern FAB Container */
.fab-container {
  position: fixed;
  bottom: 32px;
  right: 32px;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  gap: 16px;
  z-index: 9999;
}

/* Modern FAB Main Button */
.modern-fab-main {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.modern-fab-main::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), transparent);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.modern-fab-main:hover::before {
  opacity: 1;
}

.modern-fab-main:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
}

.modern-fab-main:active {
  transform: translateY(-2px) scale(0.95);
}

.modern-fab-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  color: #333;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  transform: translateX(20px) scale(0.9);
  min-width: 140px;
}

.fab-container.expanded .modern-fab-option {
  opacity: 1;
  transform: translateX(0) scale(1);
}

.modern-fab-option:hover {
  background: rgba(255, 255, 255, 1);
  transform: translateX(-4px) scale(1.02);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.option-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  flex-shrink: 0;
}

.option-label {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

/* Responsive Design */
@media screen and (max-width: 860px) {
  .fab-container {
    bottom: 20px;
    right: 20px;
  }

  .modern-close-btn {
    top: 15px;
    right: 15px;
    width: 40px;
    height: 40px;
  }

  .modern-side-panel {
    top: 70px;
    right: 10px;
    width: calc(100vw - 20px);
    max-width: 400px;
  }
}

@media screen and (max-width: 500px) {
  .modern-side-panel {
    top: 60px;
    right: 0;
    left: 0;
    width: 100vw;
    max-width: none;
    border-radius: 20px 20px 0 0;
    max-height: calc(100vh - 60px);
  }

  .fab-container {
    bottom: 20px;
    right: 20px;
  }

  .modern-fab-main {
    width: 56px;
    height: 56px;
  }

  .modern-fab-option {
    min-width: 120px;
    padding: 10px 16px;
  }
}



.report-panel-container {
  height: 100%;
  overflow-y: auto;
  padding: 15px;
}

/* Update the panel-content styles */
.panel-content {
  padding: 0;
  height: calc(100% - 60px);
  /* Adjust based on your header height */
  overflow: hidden;
  /* Changed from auto to hidden */
  display: flex;
  flex-direction: column;
}

/* Update the modern-side-panel styles */
.modern-side-panel {
  position: fixed;
  top: 80px;
  right: 20px;
  width: 420px;
  max-height: calc(100vh - 120px);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(100%) scale(0.9);
  opacity: 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
}

/* Responsive adjustments */
@media screen and (max-width: 500px) {
  .modern-side-panel {
    top: 60px;
    right: 0;
    left: 0;
    width: 100vw;
    max-width: none;
    border-radius: 20px 20px 0 0;
    max-height: calc(100vh - 60px);
  }

  .report-panel-container {
    padding: 10px;
  }
}

/* Animation effects */
.rotate-enter-active,
.rotate-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.rotate-enter-from,
.rotate-leave-to {
  opacity: 0;
  transform: rotate(-90deg) scale(0.8);
}

.fab-option-enter-active,
.fab-option-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fab-option-enter-from,
.fab-option-leave-to {
  opacity: 0;
  transform: translateX(20px) scale(0.8);
}

/* Rest of your existing styles remain the same */
.account-dropdown {
  position: relative;
  display: inline-block;
}

.account-button {
  background: none;
  border: none;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.3s;
}

.account-button:hover {
  background-color: #f0f0f0;
}

.account-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.dropdown-arrow {
  font-size: 10px;
  transition: transform 0.2s;
  margin-left: 4px;
}

.dropdown-arrow.rotate {
  transform: rotate(180deg);
}

.dropdown-content {
  position: absolute;
  right: 0;
  background-color: white;
  min-width: 280px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px;
  z-index: 1000;
  margin-top: 8px;
  animation: fadeIn 0.2s ease-out;
}

.dropdown {
  position: relative;
}

.dropdown-horizontal {
  position: relative;
}

.dropdown-vertical {
  position: relative;
}

/* ***** */
.nav-dropdown {
  display: inline-block;
}

.nav-dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.nav-dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}

.nav-dropdown-content a:hover {
  background-color: #f1f1f1;
}

.nav-dropdown:hover .nav-dropdown-content {
  display: block;
}


@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-profile {
  margin-bottom: 16px;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.profile-pic {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.profile-info {
  display: flex;
  flex-direction: column;
}

.username {
  font-weight: bold;
  font-size: 14px;
}

.fullname {
  font-size: 13px;
  color: #555;
}

.email {
  font-size: 12px;
  color: #777;
}

.profile-button,
.login-button,
.register-button,
.logout-button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
}

.profile-button {
  background-color: #f0f0f0;
  color: #333;
}

.profile-button:hover {
  background-color: #e0e0e0;
}

.login-button {
  background-color: #4285f4;
  color: white;
  margin-bottom: 8px;
}

.login-button:hover {
  background-color: #3367d6;
}

.register-button {
  background-color: #34a853;
  color: white;
}

.register-button:hover {
  background-color: #2d9248;
}

.logout-button {
  margin-top: 12px;
  background-color: #f0f0f0;
  color: #d32f2f;
}

.logout-button:hover {
  background-color: #f5e9e9;
}

.auth-buttons {
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
  margin-bottom: 12px;
}

.auth-buttons.logged-out {
  border-bottom: none;
  padding-bottom: 0;
}

header {
  background-color: var(--white);
  box-shadow: var(--box-shadow);
  position: sticky;
  top: 0;
  z-index: 900;
}

.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  flex-wrap: wrap;
}

.logo h1 {
  color: var(--primary-color);
  font-size: 24px;
  font-weight: 700;
}

.search-bar {
  display: flex;
  flex: 1;
  max-width: 500px;
  margin: 0 20px;
}

.search-bar input {
  flex: 1;
  padding: 10px 15px;
  border: 1px solid var(--gray-light);
  border-radius: var(--border-radius) 0 0 var(--border-radius);
  outline: none;
}

.search-bar .search-data-search {
  background-color: var(--primary-color);
  color: var(--white);
  border: none;
  padding: 10px 15px;
  border-radius: 0 var(--border-radius) var(--border-radius) 0;
}

.search-bar .search-data-clear {
  display: none;
}

.main-nav ul {
  display: flex;
  align-items: center;
}

.main-nav li {
  margin-left: 20px;
}

.main-nav a {
  color: var(--text-color);
  font-weight: 500;
  transition: var(--transition);
}

.main-nav a:hover,
.main-nav a.active {
  color: var(--primary-color);
}

.btn-account {
  display: flex;
  align-items: center;
  gap: 5px;
}

.cart-count {
  background-color: var(--primary-color);
  color: var(--white);
  font-size: 10px;
  width: 16.5px;
  height: 16.5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: relative;
  top: -8px;
  left: -5px;
}

.mobile-menu-toggle {
  display: none;
  font-size: 24px;
  color: var(--primary-color);
}

@media (max-width: 768px) {
  .header-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .logo {
    margin-bottom: 15px;
  }

  .search-bar {
    width: 100%;
    max-width: 100%;
    margin: 0 0 15px 0;
  }

  .mobile-menu-toggle {
    display: block;
    position: absolute;
    top: 15px;
    right: 15px;
  }

  .main-nav {
    display: none;
    width: 100%;
  }

  .main-nav.active {
    display: block;
  }

  .main-nav ul {
    flex-direction: column;
    align-items: flex-start;
  }

  .main-nav li {
    margin: 10px 0;
    width: 100%;
  }
}
</style>